import { t$2 } from '@/js/global/global'
import { shouldAnimate, intersectionWatcher } from '@/js/global/helpers'
import { register } from '@/js/global/shopify-theme-sections'
import { animateImageHeroSplit } from '@/js/global/animations'


register("image-hero-split", {
  onLoad() {
    if (shouldAnimate(this.container)) {
      // Setup animations per item
      t$2(".animation--item", this.container).forEach(item => animateImageHeroSplit(item));
    }
    this.observer = intersectionWatcher(this.container);
  },
  onUnload() {
    var _this$observer;
    this.playButtons && this.playButtons.forEach(button => button.unload());
    (_this$observer = this.observer) === null || _this$observer === void 0 ? void 0 : _this$observer.destroy();
  }
});
